var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex-1 w-full p-8 mx-auto"},[_vm._v("Centers")])}
var staticRenderFns = []

export { render, staticRenderFns }